module.exports = __webpack_public_path__ + "img/mT-top.10afd59c.png";